import { Pipe, PipeTransform } from '@angular/core';
import { languages, LanguageDef, Dictionary } from '../../../lang';
import { environment } from 'src/environments/environment';

@Pipe({
	name: 'translate',
	pure: false,
})
export class TranslatePipe implements PipeTransform {

	static instance: TranslatePipe;
	static languages: LanguageDef = languages;
	private static _language: keyof LanguageDef;
	private static _dictionary: Dictionary;
	private static _defaultLanguage: keyof LanguageDef = 'enCa';

	constructor() {
		const tp = TranslatePipe;
		let lang = tp._language;
		if (!tp.instance) {
			tp.instance = this;
			lang = tp._language = localStorage.getItem('language') || environment.language || tp._defaultLanguage;
			if (tp.languages[lang]) {
				TranslatePipe._dictionary = tp.languages[lang].dictionary;
			} else {
				console.warn(`language "${lang}" was not found, defaulting to "${tp._defaultLanguage}"`);
				TranslatePipe._dictionary = tp.languages[tp._defaultLanguage].dictionary;
			}
		}
	}

	get language() {
		return TranslatePipe._language;
	}

	getAsOptions() {
		return Object.entries(TranslatePipe.languages)
			.map(([key, val]) => ({label: val.label, id: key}));
	}

	transform(value: string, params?: object) {
		const tp = TranslatePipe,
			d = tp._dictionary;
		let txt = (d[value] || '') as string;
		if (!txt) {
			txt = (tp.languages[tp._defaultLanguage].dictionary[value]) || value;
		}
		if (params) {
			return txt.replace(/\{([a-z]*?)\}/gi, (match, prop: string) => {
				return params[prop] || params[prop] === 0 ? ('' + (params[prop])) : '';
			});
		} else {
			return txt;
		}
	}

	changeLanguage(to: keyof LanguageDef) {
		const tp = TranslatePipe,
			d = tp.languages[to];
		if (d) {
			tp._language = to;
			tp._dictionary = d.dictionary;
			localStorage.setItem('language', '' + to);
			return true;
		} else {
			throw 'dictionary_not_found';
		}
	}

}
